import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiEquipamentos = {
    getEquipamentosStatus: async () => {
        const URL = `${apiLink()}api/equipamentos/status`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error(error.message);

            })
    },
}

export default apiEquipamentos;

